var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.964 10.768a5.98 5.98 0 01-3.92 1.46C2.706 12.228 0 9.491 0 6.114S2.706 0 6.044 0a5.98 5.98 0 013.92 1.46A5.98 5.98 0 0113.884 0c3.339 0 6.045 2.737 6.045 6.114s-2.706 6.114-6.044 6.114a5.98 5.98 0 01-3.92-1.46z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.964 10.768a6.13 6.13 0 002.124-4.654 6.13 6.13 0 00-2.124-4.653A5.98 5.98 0 0113.884 0c3.339 0 6.045 2.737 6.045 6.114s-2.706 6.114-6.044 6.114a5.98 5.98 0 01-3.92-1.46z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.964 1.46a6.13 6.13 0 012.124 4.654 6.13 6.13 0 01-2.124 4.654 6.13 6.13 0 01-2.123-4.654 6.13 6.13 0 012.123-4.653z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.cc4ce760e2662aedd544e5799a175824.svg";
export { ForwardRef as ReactComponent };